export class ScrollSectionViewComponent {
    scrollToSection(sectionName: string): void {
        const el = document.getElementById(sectionName);

        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'end' });

            setTimeout(() => {
                window.scrollBy({ top: 50, behavior: 'smooth' });
            }, 200);
        }
    }
}